import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import type {PaymentData} from "../Models/PaymentData";

/**
 * Wiadomość, gdy stworzono rezerwację i dostępne są dane do jej opłacenia
 */
export class SetPaymentData extends NfComponentGlobalMessage {
    declare public paymentData: PaymentData;
    public persistentMessage = true;
    public constructor(sourceComponentId: number |MessageEvent<SetPaymentData>,paymentData?: PaymentData) {
        super(NfMessageType.SetPaymentData, arguments.length > 1);
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId as number;
            if(!paymentData) {
                throw Error('paymentData is required');
            }
            this.paymentData = paymentData;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.SetPaymentData] = (event) => {
    return new SetPaymentData(event);
}
